module.exports = __webpack_public_path__ + "static/media/Project2_Demo1.6f898b5f.mov";